import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const CHUNK_RELOAD_KEY = 'str-chunk-reload-attempted';

const reloadOnChunkError = () => {
  if (sessionStorage.getItem(CHUNK_RELOAD_KEY) === 'true') {
    sessionStorage.removeItem(CHUNK_RELOAD_KEY);
    return;
  }

  sessionStorage.setItem(CHUNK_RELOAD_KEY, 'true');
  window.location.reload();
};

window.addEventListener('error', (event) => {
  const target = event.target as HTMLScriptElement | null;
  const filename = (event as ErrorEvent).filename ?? '';
  const message = (event as ErrorEvent).message ?? '';

  const isChunkScriptError =
    target?.tagName === 'SCRIPT' ||
    filename.includes('/static/js/') ||
    message.includes('Loading chunk');

  if (isChunkScriptError) {
    reloadOnChunkError();
  }
});

window.addEventListener('unhandledrejection', (event) => {
  const reason = event.reason;
  const message =
    typeof reason === 'string'
      ? reason
      : typeof reason?.message === 'string'
        ? reason.message
        : '';

  if (message.includes('Loading chunk') || message.includes('ChunkLoadError')) {
    reloadOnChunkError();
  }
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

sessionStorage.removeItem(CHUNK_RELOAD_KEY);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
